import * as React from "react"

const SvgBookmark = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m12 18.571-4.2 1.8q-1 .426-1.9-.162T5 18.546V5.571q0-.825.588-1.412A1.93 1.93 0 0 1 7 3.57h10q.824 0 1.413.588Q19 4.746 19 5.57v12.975q0 1.075-.9 1.663t-1.9.162l-4.2-1.8Zm0-2.2 5 2.15V5.571H7v12.95z" />
  </svg>
)
export default SvgBookmark
